import { observable, runInAction } from 'mobx';
import API from '../util/ApiUtil';

type ImeiState = 'BLACKLISTED' | 'NOT_BLACKLISTED' | 'INVALID';

interface BlacklistApiResponse {
  result: ImeiState;
}

export interface BlacklistResult {
  status: 'UNINITIALIZED' | 'FETCHING' | 'FETCHED' | 'ERROR';
  imeiState?: 'BLACKLISTED' | 'NOT_BLACKLISTED' | 'INVALID';
}

class BlacklistStore {
  @observable accessor blacklistResult: BlacklistResult = {
    status: 'UNINITIALIZED',
  };

  public validateAndCheckImei(imei: string) {
    runInAction(() => {
      this.blacklistResult.imeiState = null;
    });
    const timer = window.setTimeout(() => {
      runInAction(() => {
        this.blacklistResult.status = 'FETCHING';
      });
    }, 100);
    let promise = null;
    if (!this.isIMEIValid(imei)) {
      runInAction(() => {
        this.blacklistResult.imeiState = 'INVALID';
        this.blacklistResult.status = 'FETCHED';
      });
      promise = Promise.resolve();
    } else {
      promise = this.checkImei(imei);
    }
    return promise.then(() => {
      window.clearTimeout(timer);
    });
  }

  public checkImei = async (imei: string) => {
    try {
      const response = await API.get<BlacklistApiResponse>('/blacklist', {
        params: { imei },
      });
      runInAction(() => {
        this.blacklistResult.imeiState = response.data.result;
        this.blacklistResult.status = 'FETCHED';
      });
    } catch (_e) {
      runInAction(() => {
        this.blacklistResult.status = 'ERROR';
      });
    }
  };

  public isIMEIValid(imei: string) {
    const etal = /^[0-9]{15}$/;
    if (!imei || !etal.test(imei)) {
      return false;
    }
    let sum = 0;
    let mul = 2;
    const l = 14;
    for (let i = 0; i < l; i++) {
      const digit = imei.substring(l - i - 1, l - i);
      const tp = parseInt(digit, 10) * mul;
      if (tp >= 10) {
        sum += (tp % 10) + 1;
      } else {
        sum += tp;
      }
      if (mul === 1) {
        mul++;
      } else {
        mul--;
      }
    }
    const chk = (10 - (sum % 10)) % 10;
    return chk === parseInt(imei.substring(14, 15), 10);
  }
}

export default BlacklistStore;
